import React from 'react';
import { MODAL_MODES } from '../../../../constants/enums';
import '../css/Modal.css';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from "react-icons/fa";

const BaseModal = ({ 
  title, 
  mode, 
  onClose, 
  onSave, 
  onDelete, 
  children, 
  validationErrors = [],
  saveButtonText = null,
  saveButtonDisabled = false,
  deleteConfirmation = null
}) => {
  const { t } = useTranslation();
  if (saveButtonText == null)
  {
    saveButtonText = t('admin.base_modal.save_changes')
  }
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const renderValidationErrors = () => {
    if (validationErrors.length === 0) return null;

    return (
      <div className="validation-errors">
        <h4>{t('admin.base_modal.validation_title')}</h4>
        <ul>
          {validationErrors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      </div>
    );
  };

  const renderViewMode = () => (
    <div className="modal-content">
      <div className="modal-header">
        <h2>{title}</h2>
        <button className="close-btn" onClick={onClose} aria-label="Close modal">×</button>
      </div>
      
      <div className="modal-body">
        {children}
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          {t('admin.base_modal.close')}
        </button>
      </div>
    </div>
  );

  const renderEditMode = () => (
    <div className="modal-content">
      <div className="modal-header">
        <h2>{title}</h2>
        <button className="close-btn" onClick={onClose} aria-label="Close modal">×</button>
      </div>
      
      <div className="modal-body">
        {renderValidationErrors()}
        {children}
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          {t('admin.base_modal.cancel')}
        </button>
        <button 
          className="btn btn-primary" 
          onClick={onSave}
          disabled={saveButtonDisabled}
        >
          {saveButtonText}
        </button>
      </div>
    </div>
  );

  const renderDeleteMode = () => (
    <div className="modal-content">
      <div className="modal-header">
        <h2>{title}</h2>
        <button className="close-btn" onClick={onClose} aria-label="Close modal">×</button>
      </div>
      
      <div className="modal-body">
        <div className="delete-confirmation">
          <div className="warning-icon"><FaExclamationTriangle style={{ fontSize: '48px', color: '#dc2626' }} /></div>
          {deleteConfirmation || children}
          <p className="warning-text">{t('admin.base_modal.warning_text')}</p>
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>{t('admin.base_modal.cancel')}</button>
        <button className="btn btn-danger" onClick={onDelete}>
          {title.includes('Booking') 
            ? t('admin.base_modal.delete_booking') 
            : t('admin.base_modal.delete')}
        </button>
      </div>
    </div>
  );

  const renderModalContent = () => {
    switch (mode) {
      case MODAL_MODES.VIEW:
        return renderViewMode();
      case MODAL_MODES.EDIT:
        return renderEditMode();
      case MODAL_MODES.DELETE:
        return renderDeleteMode();
      default:
        return null;
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-wrapper" onClick={(e) => e.stopPropagation()}>
        {renderModalContent()}
      </div>
    </div>
  );
};

export default BaseModal;